(function ($) {

	var nav_pos = $(".pcHeaderMenu").offset().top;
	var nav_height = $(".pcHeaderMenu").outerHeight();
	$(window).scroll(function () {
		if ($(this).scrollTop() > nav_pos) {
			$(".pcHeaderMenu").addClass("fixed");
		} else {
			$(".pcHeaderMenu").removeClass("fixed");
		}
	});

	if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
		$(window).on('scroll', function () {
			if ($(window).scrollTop() > 100) {
				$('.circleMenu').fadeIn(400);
			} else {
				$('.circleMenu').fadeOut(400);
			}
		});
	}

	if ($('.mainSlider').length > 0) {
		$('.mainSlider').slick({
			autoplay: true,
			dots: false,
			arrows: false
		});
	}

	if ($('.catchSection__slider').length > 0) {
		$('.catchSection__slider').slick({
			autoplay: true,
			dots: true,
			arrows: false
		});
	}

	if ($('.slider2,.slider3').length > 0) {
		$('.slider2,.slider3').slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 0,
			cssEase: 'linear',
			speed: 50000,
			swipe: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			slidesToShow: 2.9,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1.2,
					}
				},
			]
		});
	}

	$('.acdnButton').on('click', function () {
		$(this).toggleClass('isActive');
	})

})(jQuery);

const listElm = document.getElementById('resultArea');
const loadBtn = document.getElementById('loadBtn');

const loadPostFunc = (() => {
	let paged = 2;
	if(!loadBtn) {
		return false;
	}
	const file = loadBtn.getAttribute('data-my-load_file');
	const cat = loadBtn.getAttribute('data-my-cat');
	return () => {
		const xhr = new XMLHttpRequest();
		xhr.onload = () => {
			if (xhr.status != 200) {
				return false;
			}
			paged++;
			const posts = JSON.parse(xhr.responseText);
			listElm.insertAdjacentHTML('beforeend', posts.html);
			if (posts.is_last) {
				loadBtn.remove();
			} else {
				loadBtn.classList.remove('loading');
			}
		}
		xhr.open('GET', file + '?paged=' + paged + '&cat=' + cat, true);
		xhr.send();
	};
})();

if (loadBtn) {
	loadBtn.addEventListener('click', () => {
		loadBtn.classList.add('loading');
		loadPostFunc();
	}, false);
}
